<template>
  <button
    :type="type"
    class="btn"
    :class="variantClass"
    :disabled="loading || disabled"
  >
    <Spinner v-if="loading && !disabled" size="sm" class="mr-2" />
    <slot />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import Spinner from './Spinner.vue';

let {
  type = 'button',
  variant = 'default', // 'success', 'danger', 'default'
  loading = false,
  disabled = false,
} = defineProps(['type', 'variant', 'loading', 'disabled'])

let variantClass = computed(() => `btn-${variant}`)
</script>
